import { render, staticRenderFns } from "./InvoiceConcept.vue?vue&type=template&id=2bcdb9b2&"
import script from "./InvoiceConcept.vue?vue&type=script&lang=js&"
export * from "./InvoiceConcept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports